/**
 * Uniform error envelope produced by HttpExceptionFilter in portal-backend.
 * See cosmo-bud-portal-backend/src/common/filters/http-exception.filter.ts.
 *
 * `errorCode` is a stable string the frontend switches on
 * (e.g. INVALID_CREDENTIALS, ACCOUNT_LOCKED, REFRESH_INVALID).
 * Never display the `message` field for 5xx (it may leak internals).
 */
import { z } from 'zod';

export const ErrorEnvelopeSchema = z.object({
  statusCode: z.number().int(),
  errorCode: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
  path: z.string().optional(),
  timestamp: z.string().optional(),
  requestId: z.string().optional(),
});

export type ErrorEnvelope = z.infer<typeof ErrorEnvelopeSchema>;
